import React from 'react';

interface StrengthProps {
  strong: Boolean;
}

function Strength({ strong }: StrengthProps) {
  return (
    <div className="flex items-center my-2">
      <div
        className={`relative mr-4 h-1 flex-grow rounded-[2px] bg-neutral-light before:absolute before:h-1 before:rounded-[2px] before:content-[''] ${
          strong ? 'before:w-full before:bg-success-dark' : 'before:w-1/2 before:bg-warning-medium'
        }`}
      />
      <span className="text-neutral-dark">Senha {strong ? 'forte' : 'fraca'}</span>
    </div>
  );
}

export default Strength;
